import * as React from 'react';
import styles from './index.less';
import { CSSProperties } from 'react';
import { FUtil } from '@freelog/tools-lib';

interface FCoverImageProps {
  src: string;
  /** 数字为固定像素；字符串如 '100%' 用于流式卡片 */
  width: number | string;
  /**
   * contain：图在容器内居中完整显示，且宽或高至少一边贴满 100%
   * （跳过 # 裁剪像素定位，避免固定宽高导致留白过大）
   */
  fit?: 'contain';

  style?: CSSProperties;
  className?: string;
}

interface FCoverImageStates {
  imgStyle: {
    width: number;
    height: number;
    translateX: number;
    translateY: number;
    transform: string;
  } | null;
  $hasError: boolean;
}

function FCoverImage({
  src = '',
  width,
  fit,
  style = {},
  className = '',
}: FCoverImageProps) {

  const [$imgStyle, set$imgStyle] = React.useState<FCoverImageStates['imgStyle']>(null);
  const [$hasError, set$hasError] = React.useState<FCoverImageStates['$hasError']>(false);
  // 流式宽度时裁剪计算用默认基准宽
  const cropBaseWidth = typeof width === 'number' ? width : 280;
  const useContainFit = fit === 'contain';

  React.useEffect(() => {
    if (useContainFit || !src.includes('#')) {
      set$imgStyle(null);
    } else {
      const { x, y, w, h, r, width: wh, height: ht } = hashString(src);
      const scale: number = cropBaseWidth / w;
      set$imgStyle({
        width: wh * scale,
        height: ht * scale,
        translateX: -x * scale,
        translateY: -y * scale,
        transform: `rotate(${r})`,
      });
    }
  }, [src, cropBaseWidth, useContainFit]);

  // console.log(src, 'SSSRRRRCCCCCCsdiopfjsldkjlk');
  return (<div
    className={[styles.FCoverImage, className].join(' ')}
    style={{
      ...style,
      width,
      // 允许调用方覆盖（如主题卡片固定高度）；默认 4:3
      aspectRatio: style.aspectRatio ?? 4 / 3,
    }}
  >
    {
      $imgStyle
        ? (<img
          src={src}
          alt={''}
          style={{
            width: $imgStyle.width,
            height: $imgStyle.height,
            transform: `translateX(${$imgStyle.translateX}px) translateY(${$imgStyle.translateY}px)`,
          }}
        />)
        : (<img
          src={!$hasError && !!src ? src : FUtil.Domain.STATIC_ORIGIN + '/static/default_cover.png'}
          style={
            useContainFit
              ? {
                  // 宽高都 100% + contain：完整显示且至少一边贴满容器
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }
              : {
                  maxWidth: '100%',
                  maxHeight: '100%',
                }
          }
          alt={''}
          onError={(e) => {
            // console.log(e, 'EEEEEEEEEEEEEEEEEEEeeeeee');
            set$hasError(true);
          }}
        />)
    }
  </div>);
}

export default FCoverImage;

interface HashStringReturn {
  x: number;
  y: number;
  w: number;
  h: number;
  r: number;
  width: number;
  height: number;
}

function hashString(str: string): HashStringReturn {
  let params = str.split('#')[1];
  let param = params.split('&');
  let obj: { [key: string]: number } = {}; // 用一个对象存储目标值
  for (const kv of param) {
    let [key, value] = kv.split('=');
    obj[key] = Number(value);
  }
  if (typeof obj['r'] !== 'number') {
    obj['r'] = 0;
  }
  return obj as any;
}

